import React from 'react';
import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import ErrorInterceptor from 'components/common/ErrorInterceptor';
import UpdatePassword from 'components/common/UpdatePassword';
import { Redirect } from 'react-router-dom';
import { Location, History } from 'history';
import { routes } from 'utils/routeHelper';
import { setupAccountSuccess } from 'actions/authenticate';
import { AuthClientInstance } from 'api/authClientInstance';

export const TIME_OUT = 2000;

interface IOwnProps {
  location: Location;
  history: History;
}

interface IDispatchProps {
  setupAccountSuccess: () => void;
}

interface IStateProps {
  isSetupAccountSuccess: Nullable<boolean>;
}

export type SetupAccountProp = IStateProps & IOwnProps & IDispatchProps;

interface IState {
  isRedirect: boolean;
  isSubmitting: boolean;
}

const SetupAccount = (props: SetupAccountProp) => {
  const { isSetupAccountSuccess, location } = props;

  const defaultState = {
    isRedirect: false,
    isSubmitting: false,
  };
  const [state, setState] = React.useState<IState>(defaultState);
  const { isSubmitting } = state;

  const setupUserAccount = async (newPassword: string, resetToken: string) => {
    try {
      setState((prevState: IState) => ({ ...prevState, isSubmitting: true }));
      await AuthClientInstance.get().updatePassword({
        updatePasswordDTO: {
          token: resetToken,
          password: newPassword,
        },
      });
      setState((prevState: IState) => ({
        ...prevState,
        isRedirect: true,
        isSubmitting: false,
      }));
    } catch (e) {
      setState((prevState: IState) => ({ ...prevState, isSubmitting: false }));
      ErrorInterceptor.error(e);
    }
  };

  if (state.isRedirect) {
    return (
      <Redirect to={routes.LOGIN_IN} data-testid="setup-account-redirect" />
    );
  }

  return (
    <UpdatePassword
      isSubmitting={isSubmitting}
      updatePassword={setupUserAccount}
      updatePasswordSuccess={isSetupAccountSuccess}
      errorMessage={null}
      message="Your account has been activated."
      location={location}
    />
  );
};

const mapStateToProps = ({ authenticate }: IRootStateType) => {
  return {
    isSetupAccountSuccess: authenticate.setupAccountSuccess,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      setupAccountSuccess,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(SetupAccount);
